export const deepEqual = (obj1, obj2) => {
  // it's just the same object. No need to compare.
  if (obj1 === obj2) {
    return true;
  }

  // compare primitives
  if (isPrimitive(obj1) && isPrimitive(obj2)) {
    return obj1 === obj2;
  }

  // False if either are undefined
  if (obj1 === undefined || obj2 === undefined) {
    return false;
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }

  // compare objects with same number of keys
  // eslint-disable-next-line guard-for-in
  for (const key in obj1) {
    if (!(key in obj2)) {
      return false;
    }

    // other object doesn't have this prop
    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};

// check if value is primitive
export const isPrimitive = obj => {
  return obj !== Object(obj);
};
